import { render, staticRenderFns } from "./KnowledgeBaseTable.vue?vue&type=template&id=68e7e37c"
import script from "./KnowledgeBaseTable.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseTable.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseTable.vue?vue&type=style&index=0&id=68e7e37c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports